<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
		<div class="search">
			<el-input v-model="xueyuanMc" placeholder="学员、学员编码、手机号" clearable style="width: 290px;margin-bottom: 10px;"></el-input>
			<el-button @click="findXueyuanList" style="margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
		</div>
    <el-row class="xueyuan-list">
      <el-col :span="12">
        <div 
					class="hyxy-box"
					v-for="(item, index) in xueyuanList"
					:key="item.id"
					@click="selectXueyuan(item)"
					:style="item.isSelect?'margin-bottom: 10px;border: 1px solid #18CE58;':'margin-bottom: 10px;'"
					v-if="(index%2) === 0">
					<div :class="item.xb==0?'xbjb-view':'xbjb-view xbnv-color'">
						<span style="display: inline-block;transform: rotate(45deg);">{{item.xb == 0 ? '男' : '女'}}</span>
					</div>
					<span v-if="item.isSelect" class="el-icon-success"></span>
					<div style="width: calc(100% - 405px);min-width: 120px;line-height: 50px;">{{item.xueyuanBm}}</div>
					<div :title="item.xueyuanMc" class="xymc-block">{{item.xueyuanMc}}</div>
					<div style="width: 110px;">{{item.sjh}}</div>
					<div style="width: 100px;">积分: {{item.zhjfye}}</div>
					<div class="hyxy-hyqk" @click.stop="changeOpenStatus(index)">
						<template v-if="item.hyrqList.length">
							会员情况
							<i class="el-icon-arrow-down" v-if="!item.isOpen"></i>
							<i class="el-icon-arrow-up" v-if="item.isOpen"></i>
						</template>
					</div>
					<div v-if="item.isOpen" class="hyrq-list">
						<div v-for="hyrq in item.hyrqList">
						  {{ formatDate(new Date(hyrq.hyksrq), 'yyyy/MM/dd') }} - {{ formatDate(new Date(hyrq.hyjsrq), 'yyyy/MM/dd') }}
							&nbsp;&nbsp;&nbsp;
							<div style="display: inline-block;letter-spacing: 1px;">
								{{hyrq.hyts}}天;&nbsp;&nbsp;<span v-if="hyrq.mrxhjf">{{hyrq.mrxhjf}}积分/天;</span>
							</div>
						</div>
					</div>
				</div>
      </el-col>
			<el-col :span="12">
			  <div 
					class="hyxy-box"
					v-for="(item, index) in xueyuanList"
					:key="item.id"
					@click="selectXueyuan(item)"
					:style="item.isSelect?'margin-bottom: 10px;border: 1px solid #18CE58;':'margin-bottom: 10px;'"
					v-if="(index%2) === 1">
					<div :class="item.xb==0?'xbjb-view':'xbjb-view xbnv-color'">
						<span style="display: inline-block;transform: rotate(45deg);">{{item.xb == 0 ? '男' : '女'}}</span>
					</div>
					<span v-if="item.isSelect" class="el-icon-success"></span>
					<div style="width: calc(100% - 405px);min-width: 120px;line-height: 50px;">{{item.xueyuanBm}}</div>
					<div :title="item.xueyuanMc" class="xymc-block">{{item.xueyuanMc}}</div>
					<div style="width: 110px;">{{item.sjh}}</div>
					<div style="width: 100px;">积分: {{item.zhjfye}}</div>
					<div class="hyxy-hyqk" @click.stop="changeOpenStatus(index)">
						<template v-if="item.hyrqList.length">
							会员情况
							<i class="el-icon-arrow-down" v-if="!item.isOpen"></i>
							<i class="el-icon-arrow-up" v-if="item.isOpen"></i>
						</template>
					</div>
					<div v-if="item.isOpen" class="hyrq-list">
						<div v-for="hyrq in item.hyrqList">
						  {{ formatDate(new Date(hyrq.hyksrq), 'yyyy/MM/dd') }} - {{ formatDate(new Date(hyrq.hyjsrq), 'yyyy/MM/dd') }}
						  &nbsp;&nbsp;&nbsp;
							<div style="display: inline-block;letter-spacing: 1px;">
								{{hyrq.hyts}}天;&nbsp;&nbsp;<span v-if="hyrq.mrxhjf">{{hyrq.mrxhjf}}积分/天;</span>
							</div>
						</div>
					</div>
				</div>
			</el-col>
<!--      <div style="text-align:center;margin: auto;" v-if="xueyuanList.length == 0">
        <span>暂无学员</span>
      </div>-->
      <div style="text-align:center;margin: auto;" v-if="xueyuanList.length == 0">
				<div class="no-data">
					<img src="../../assets/img/zanwu_baise3.png" />
					<p>暂无学员,请查询......</p>
				</div>
      </div>
    </el-row>
    <el-row style="margin: 18px 0 10px 0;">
			<el-col :span="8" style="text-align: right;">
				<div class="dataCls">
				  <label style="width: 160px;">充值天数：</label>
				  <el-input
				      v-model="czts"
				      @input="handleIntegerInput"
				      min="0"
				      type="Number"
				      placeholder="请输入充值天数"
				      @change="changeDate"
				      clearable>
				  </el-input>
				</div>
			</el-col>
			<el-col :span="8" style="text-align: center;">
				<div class="dataCls">
				  <label style="width: 160px;">会员开始日期：</label>
				  <el-date-picker
				    v-model="hyksrq"
				    type="date"
				    placeholder="选择日期"
				    @change="changeDate"
				    :picker-options="pickerOptions">
				  </el-date-picker>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="dataCls">
				  <label style="width: 160px;">充值后到期日：</label>
				  <span style="width: 200px;display: inline-block;"> {{ hyjsrq }}</span>
				</div>
			</el-col>
			<el-col :span="8" style="text-align: right;">
				<div class="dataCls">
				  <label style="width: 160px;">机构余额：</label>
				  <span style="color: #18CE58;width: 200px;display: inline-block;text-align: left;"> {{jggl.zhyejf}} </span>
				</div>
			</el-col>
			<el-col :span="8" style="text-align: center;">
				<div class="dataCls">
				  <label style="width: 160px;">消耗积分：</label>
				  <span style="color: #FA5151;width: 200px;display: inline-block;text-align: left;"> {{ czts * jggl.sxjf }} </span>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="dataCls">
				  <label style="width: 160px;">充值后机构剩余积分：</label>
				  <span style="color: #18CE58;"> {{ jggl.zhyejf - (czts * jggl.sxjf) }} </span>
				</div>
			</el-col>
    </el-row>
		<div style="text-align: center;">
			<el-button type="primary" @click="kthySave">确认充值</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'kthy',
	data() {
		return {
      jgglId: sessionStorage.getItem("jgglId"),
      xueyuanMc: '',//学员名称
      curDate: new Date().getTime(),
      xueyuanList: [],
			loading: false,
      xueyuanId: '',
      czts: '',//充值天数
      isSelect: false,
      jggl: {},//机构信息
      jglx: {},//机构类型
      hyksrq: '',//会员开始日期
      hyjsrq: '',//会员到期日
      finalDate: '',//最终会员到期日
      selectXy: {},
      // ...其他数据
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 禁用今天之前的日期
        }
      },
      hyrqList: [],
		}
	},
  components:{},
	created() {
	},
  mounted() {
    this.findJgglView();
  },
	methods: {
    handleIntegerInput(value) {
      // 只保留整数部分
      const intValue = value ? parseInt(value, 10) : '';
      if (!isNaN(intValue) && intValue >= 0) {
        this.czts = intValue;
      } else {
        this.czts = '';
      }
    },
    changeDate() {
      if (!this.hyksrq || !this.czts) {
        this.hyjsrq = '';
        return;
      }

      const startDate = new Date(this.hyksrq);
      startDate.setDate(startDate.getDate() + parseInt(this.czts));
      this.hyjsrq = startDate.toISOString().split('T')[0]; // 格式化为 YYYY-MM-DD
    },
    // 获取数据
    findXueyuanList() {
      var _this = this;
      var params = {
        jgglId: _this.jgglId,
        xueyuanMc: _this.xueyuanMc
      }
      _this.loading = true;
      _this.$post("xueyuan/XueyuanController/xueyuanList", params).then(rep => {
        _this.loading = false;
        if (rep.code == 1) {
					var reslist = [];
					rep.result.list.forEach(item=>{
						if(item.sjh!=null){
							reslist.push(item);
						}
					})
          // 使用map创建新对象确保响应式
          _this.xueyuanList = reslist.map(item => ({
            ...item,
            isSelect: false
          }));
          //_this.selectXueyuan(_this.selectXy);
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    // 选择学员（实现严格单选）
    selectXueyuan(item){
      this.selectXy = item;
      if(!item.sjh){
        this.$message({
          type: "error",
          message: "未绑定学生端手机号"
        });
        return;
      }
      // 先记录当前选中状态
      const wasSelected = item.isSelect;

      //this.getXueyuanHyrqList(item.id);

      // 创建新数组确保响应式更新
      const newList = this.xueyuanList.map(item2 => {
        return {
          ...item2,
          isSelect: item2.id === item.id ? !wasSelected : false
        };
      });

      // 解析 hyrqList 获取最终会员结束日期
      if (item.hyrqList && item.hyrqList.length > 0) {
        const latestRecord = item.hyrqList.reduce((prev, current) => {
          return new Date(prev.hyjsrq) > new Date(current.hyjsrq) ? prev : current;
        });
        this.finalDate = latestRecord.hyjsrq; // 设置最终会员结束日期
      } else {
        this.finalDate = ''; // 没有记录则清空
      }

      this.xueyuanList = newList;

      // 同步更新选中ID（如果取消选中则清空）
      this.xueyuanId = wasSelected ? '' : item.id;
    },
    getXueyuanHyrqList(xueyuanId){
      var _this = this;
      _this.$post('xueyuan/XueyuanController/findHyrqList',{xueyuanId: xueyuanId}).then((rep) => {
        if (rep.code == 1) {
          _this.hyrqList = rep.result.list;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    kthySave(){
      var _this = this;
      if(!_this.xueyuanId){
        _this.$message({
          type: "error",
          message: '请选择学员'
        });
        return;
      }
      if(!_this.czts){
        _this.$message({
          type: "error",
          message: '请输入充值天数'
        });
        return;
      }else{
        if(_this.czts <= 0){
          _this.$message({
            type: "error",
            message: '充值天数不能小于等于0'
          });
          return;
        }
      }
      if(!_this.hyksrq){
        _this.$message({
          type: "error",
          message: '请选择会员开始日期'
        });
        return;
      }
      if(!_this.hyjsrq){
        _this.$message({
          type: "error",
          message: '请选择会员到期日'
        });
        return;
      }
      if(_this.jggl.zhyejf < (_this.czts * _this.jggl.sxjf)){
        _this.$message({
          type: "error",
          message: '机构余额不足'
        });
        return;
      }
      _this.$confirm('是否确认充值', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {
          xueyuanId: _this.xueyuanId,
          ktts: _this.czts,
          hyksrq: _this.hyksrq,
          hyjsrq: _this.hyjsrq,
          xhjf: (_this.czts * _this.jggl.sxjf),
          mrxhjf: _this.jggl.sxjf
        }
        this.$post("xueyuan/XueyuanController/xueyuanKthy", params,'json').then(rep => {
          if (rep.code == '1') {
            this.$message({
              type: "success",
              message: '充值成功'
            });
            this.findXueyuanList();
            this.findJgglView();
            //this.xueyuanId='';
          } else {
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      })
    },
    findJgglView(){
      var _this = this;
      _this.$post('jggl/JgglController/jgglView',{id: _this.jgglId}).then((rep) => {
        if (rep.code == 1) {
          _this.jggl = rep.result.jggl;
          //_this.findJglxView(_this.jggl.jglxId);
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    findJglxView(jglxId){
      var _this = this;
      _this.$post('jggl/JgglController/jglxView',{id: jglxId}).then((rep) => {
        if (rep.code == 1) {
          _this.jglx = rep.result.jglx;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
		changeOpenStatus(index){
			this.$set(this.xueyuanList[index],'isOpen',!this.xueyuanList[index].isOpen);
		}
	},
}
</script>

<style lang="less">
.school-manage {
	.search {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 10px;
		.el-select,
		.el-input {
			margin-right: 10px;
		}
	}
  .xueyuan-list{
    height: 320px;
    overflow: auto;
		border-bottom: 1px solid #EBEEF5;
		.hyxy-box{
			position: relative;
			// height: 50px;
			box-shadow: 0px 1px 6px 0px rgba(3,20,47,0.13);
			border: 1px solid #DCDFE6;
			border-radius: 5px;
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			text-align: left;
			padding: 0 0 0 40px;
			cursor: pointer;
			overflow: hidden;
			div{
				display: inline-block;
			}
			.xbjb-view{
				position: absolute;
				width: 45px;
				height: 45px;
				line-height:68px;
				left: -22px;top: -22px;
				background: #D9EEFF;
				text-align: center;
				vertical-align: bottom;
				transform: rotate(-45deg);
				color: #666666;
			}
			.xbnv-color{
				background: #FDE2E2;
			}
			.xymc-block{
				width: 75px;
				margin-right: 5px;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
				vertical-align:middle;
				margin-bottom: 4px;
			}
			.hyxy-hyqk{
				// width: 95px;
				color: #559CF4;
				cursor: pointer;
				i{margin-left: 5px;}
			}
			.hyrq-list{
				line-height: 28px;
				margin-bottom: 10px;
				div{
					display: block;
				}
			}
			.el-icon-success{
				color: #18CE58;
				position: absolute;
				left: 14px;
				top: 16px;
				font-size: 18px;
			}
		}
		.el-col:nth-of-type(2n) .hyxy-box{
			margin-left: 10px;
		}
		.el-col:nth-of-type(2n-1) .hyxy-box{
			margin-right: 10px;
		}
  }

  /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
  .xueyuan-list::-webkit-scrollbar {
    display: none;
  }

  /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
  .xueyuan-list {
    -ms-overflow-style: none;  /* IE 和 Edge */
    scrollbar-width: none;  /* Firefox */
  }

  .item-content{
    padding: 10px 20px 10px;
    height: 140px;
    overflow-y: auto;
  }

  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 10px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 280px;
    cursor: pointer;
  }
  .dataCls{
		display: block;
		height: 40px;
		line-height: 40px;
		margin-bottom: 10px;
    label{
      display: inline-block;
      text-align: right;
      font-size: 16px;
      font-weight: 500;
    }
    .el-input,
    .el-date-picker{
      width: 200px;
    }
  }
}
</style>
